import { api } from "../lib/apiClient";

export async function getFilters() {
  const { data } = await api.get("/job_filters")
  return data
}

export async function getItems() {
  const { data } = await api.get("/jobs/by_category")
  return data;
}

export async function getItem(id) {
  const { data } = await api.get(`/jobs/by_id/${id}`)
  return data;
}
